module.exports = __webpack_public_path__ + "img/pay2.1ea2515f.png";